import { Routes, Route } from 'react-router-dom';

import { Home } from '../screens';
import { BookingsRouter } from './bookings.router';
import { DriversRouter } from './drivers.router';
import { SettingsRouter } from './settings.router';
import { SettingsHeader } from '../components/Settings/Header';
import { RequestsRouter } from './requests.router';

const DashboardRouter = () => (
    <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/requests" element={<RequestsRouter />} />
        <Route path="/bookings/*" element={<BookingsRouter />} />
        <Route path="/drivers/*" element={<DriversRouter />} />
        <Route
            path="/settings/*"
            element={(
                <SettingsHeader>
                    <SettingsRouter />
                </SettingsHeader>
            )}
        />
    </Routes>
);
export { DashboardRouter };
